import moment from "moment";

/**
 * Varios campos de la API viajan como DD-MM-YYYY: vencimiento de VTV, de licencia y de ART. Los
 * `FormDatePicker` trabajan con `Date`, así que la conversión de ida y vuelta pasa siempre por acá.
 * (El envío usa `formatVtvExpirationDateForApi` en useEvent; esto es el lado de la lectura.)
 */
export const parseApiDate = (value: unknown): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const parsed = moment(value as string, "DD-MM-YYYY", true);
  return parsed.isValid() ? parsed.toDate() : null;
};

/**
 * Igual que `parseApiDate` pero tolera además las fechas que la API devuelve en ISO (el seguro del
 * vehículo viaja en DD-MM-YYYY para transportistas y en ISO para el resto). Devuelve null en vez de
 * un `Date` inválido: un Invalid Date sobrevive hasta el submit y ahí revienta con "Invalid time
 * value" al serializarse.
 */
export const parseApiOrIsoDate = (value: unknown): Date | null => {
  const fromApi = parseApiDate(value);
  if (fromApi) return fromApi;
  if (typeof value !== "string" || !value) return null;
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};
